export default __webpack_public_path__ + "static/media/2.97088ba4.png";